const { encodeQ, getId, getPatchOpsArray } = require( '@leverege/api/src/Utils' )

const Dep = {

  createProject( data, options ) {
    const { name, icon } = data
    return this.post( `v1/project${encodeQ( options )}`, { name, icon } )
  },

  deleteProject( project, options ) {
    project = getId( project )
    return this.delete( `v1/project/${project}${encodeQ( options )}` )
  },

  addApiAccess( project, apiAccess ) {
    project = getId( project )
    return this.post( `v1/project/${project}/apiAccess`, apiAccess )
  },

  updateApiAccess( apiAccess, patchOps ) {
    patchOps = getPatchOpsArray( patchOps )
    return this.patch( `v1/project/${apiAccess.projectId}/apiAccess/${apiAccess.id}`, patchOps )
  },

  removeApiAccess( apiAccess ) {
    return this.delete( `v1/project/${apiAccess.projectId}/apiAccess/${apiAccess.id}` )
  },

  getBlueprints( projectId, options ) {
    return this.get( `v1/project/${projectId}/blueprint${encodeQ( options )}` )
  },
  // ----------- Blueprint 
  addBlueprint( project, blueprint ) {
    const id = typeof project === 'string' ? project : project.id
    return this.post( `v1/project/${id}/blueprint`, blueprint );
  },

  getBlueprint( projectId, blueprintId, options ) {
    // backward compat
    if ( options == null ) {
      options = {
        children : 'attribute',
        attribute : { perPage : 10000 }
      }
    }
    return this.get( `v1/project/${projectId}/blueprint/${blueprintId}${encodeQ( options )}` )
  },

  updateBlueprint( blueprint, patchOps ) {
    patchOps = getPatchOpsArray( patchOps )
    return this.patch( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}`, patchOps )
  },

  removeBlueprint( blueprint ) {
    return this.delete( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}` )
  },

  simulateBlueprint( blueprint ) {
    return this.post( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/simulate` );
  },

  // ----------- Attributes 
  
  addAttribute( blueprint, attribute ) {
    return this.post( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/attribute`, attribute );
  },
  
  updateAttribute( blueprint, attribute, patchOps ) {
    patchOps = getPatchOpsArray( patchOps )
    return this.patch( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/attribute/${attribute.id}`, patchOps );
  },

  removeAttribute( blueprint, attribute ) {
    return this.delete( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/attribute/${attribute.id}`, { } );
  },

  removeAttributes( blueprint, attributeIds ) {
    return this.delete( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/attributes`, attributeIds );
  },

  // ----------- Alert 
  
  getAlert( blueprint, alert ) {
    alert = getId( alert )
    return this.get( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/alert/${alert}` );
  },

  addAlert( blueprint, alert ) {
    return this.post( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/alert`, alert );
  },
  
  updateAlert( blueprint, alert, patchOps ) {
    patchOps = getPatchOpsArray( patchOps )
    alert = getId( alert )
    return this.patch( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/alert/${alert}`, patchOps );
  },

  removeAlert( blueprint, alert ) {
    alert = getId( alert )
    return this.delete( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/alert/${alert}`, { } );
  },

  removeAlerts( blueprint, alertIds ) {
    return this.delete( `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}/alerts`, alertIds );
  },

  // ----------- Contact 
  
  getContacts( system, options ) {
    system = getId( system )
    return this.get( `v1/system/${system}/contact/${encodeQ( options )}` );
  },

  getContact( system, contact, options ) {
    system = getId( system )
    contact = getId( contact )
    return this.get( `v1/system/${system}/contact/${contact}${encodeQ( options )}` );
  },

  addContact( system, contact ) {
    system = getId( system )
    return this.post( `v1/system/${system}/contact`, contact );
  },
  
  updateContact( system, contact, patchOps ) {
    system = getId( system )
    contact = getId( contact )
    patchOps = getPatchOpsArray( patchOps )
    return this.patch( `v1/system/${system}/contact/${contact}`, patchOps );
  },

  removeContact( system, contact ) {    
    system = getId( system )
    contact = getId( contact )
    return this.delete( `v1/system/${system}/contact/${contact}`, { } );
  },

  // ----------- Scenario
  addScenario( projectId, scenario ) {
    return this.post( `v1/project/${projectId}/scenario`, scenario );
  },

  getScenarios( projectId, blueprintId, options ) {
    if ( blueprintId ) {
      return this.get( `v1/project/${projectId}/blueprint/${blueprintId}/scenario${encodeQ( options )}` )
    }
    return this.get( `v1/project/${projectId}/scenario${encodeQ( options )}` )
  },

  getScenario( projectId, scenarioId, options ) {
    return this.get( `v1/project/${projectId}/scenario/${scenarioId}${encodeQ( options )}` )
  },
  
  putScenario( scenario ) {
    return this.put( `v1/project/${scenario.projectId}/scenario/${scenario.id}`, scenario )
  },

  // updateScenario( system, patchOps ) {
  //   return this.patch( `v1/system/${system.id}/`, patchOps )
  // }

  removeScenario( projectId, scenarioId ) {
    return this.delete( `v1/project/${projectId}/scenario/${scenarioId}` )
  },
  playScenario( systemId, deviceId, scenarioId, options ) {
    options = options || {}
    options.scenarioId = scenarioId
    return this.post( `v1/system/${systemId}/device/${deviceId}/scenario`, options )
  },
  stopScenario( systemId, deviceId ) {
    return this.delete( `v1/system/${systemId}/device/${deviceId}/scenario` )
  },
  
  // ----------- Systems
  
  addSystem( projectId, system ) {
    return this.post( `v1/project/${projectId}/system`, system );
  },

  getSystems( projectId, options ) {
    return this.get( `v1/project/${projectId}/system${encodeQ( options )}` )
  },

  getSystem( systemId, options ) {
    return this.get( `v1/system/${systemId}${encodeQ( options )}` )
  },

  updateSystem( system, patchOps ) {
    system = getId( system )
    patchOps = getPatchOpsArray( patchOps )

    return this.patch( `v1/system/${system}/`, patchOps )
  },

  removeSystem( system ) {
    return this.delete( `v1/project/${system.projectId}/system/${system.id}` )
  },

  // restartSystemTransponders( system, options ) {
  //   let id = getId( system )
  //   return this.put( `v1/system/${id}/restartTransponders${encodeQ(options)}`, null )
  // }
  /*
  requestDataToken( systemId ) {
    return this.get( `v1/${systemId}/dataToken` )
  }
  */

  // ----------- Device
  
  addDevice( systemId, device ) {
    return this.post( `v1/system/${systemId}/device`, device );
  },

  getDevices( systemId, options ) {
    return this.get( `v1/system/${systemId}/device${encodeQ( options )}` )
  },

  getDevice( systemId, deviceId, options ) {
    return this.device( { id : deviceId, systemId } ).get( options )
    //    return this.get( `v1/system/${systemId}/device/${deviceId}${encodeQ(options)}` )
  },

  /**
   *  Get the device by networkId, key and value
   **/
  getDeviceByNetworkAlias( networkId, key, value, options ) {
    networkId = getId( networkId )
    return this.get( `v1/network/${networkId}/device/${key}/${value}${encodeQ( options )}` )
  },

  /**
   * Sets the name of of the device on the specified network
   **/
  setNetworkAlias( device, networkId, key, value, options ) {
    return this.device( device ).setNetworkAlias( networkId, key, value, options )
    // const add = [ { op:"replace", path : 'networkAliases/' + networkId + '/' + key, value } ]
    // return this.updateDevice( device, add )
  },

  /**
   * @deprecated Use getDeviceByNetworkAlias
   * Get the device by alias. There are two variant of this:
   *    getDeviceByAlias( 'iothub', 'device-2' ) - looks up the iothub alias
   *    getDeviceByAlias( 'value' ) - uses 'uuid' as the alias key
   **/
  getDeviceByAlias( aliasKey, aliasValue, options ) {
    const isValue = aliasValue != null && typeof aliasValue !== 'object'
    if ( arguments.length >= 2 && isValue ) {
      return this.get( `v1/deviceByAlias/${aliasKey}/${aliasValue}${encodeQ( options )}` )
    }
    return this.get( `v1/deviceByAlias/uuid/${aliasKey}${encodeQ( options )}` )
  },
  
  updateDevice( device, patchOps, options ) {
    return this.device( device ).update( patchOps, options )
    // patchOps = getPatchOpsArray( patchOps )
    // return this.patch( `v1/system/${device.systemId}/device/${device.id}`, patchOps )
  },

  messageDevice( device, message, options ) {
    return this.device( device ).message( message, options )
    //    return this.post( `v1/system/${device.systemId}/device/${device.id}/sendMessage${encodeQ(options)}`, message )
  },

  startDevice( device, options ) {
    return this.device( device ).startSim( options )
    //    return this.put( `v1/system/${device.systemId}/device/${device.id}/start${encodeQ(options)}`, data )
  },

  pauseDevice( device, options ) {
    return this.device( device ).pauseSim( options )
    // return this.put( `v1/system/${device.systemId}/device/${device.id}/pause${encodeQ(options)}`, null )
  },

  resetDevice( device, options ) {
    return this.device( device ).resetSim( options )
    // return this.put( `v1/system/${device.systemId}/device/${device.id}/reset${encodeQ(options)}`, null )
  },

  // restartDeviceTransponder( device, options ) {
  //   return this.put( `v1/system/${device.systemId}/device/${device.id}/restartTransponder${encodeQ(options)}`, null )
  // }

  deviceLog( device ) {
    return this.get( `v1/system/${device.systemId}/device/${device.id}/log`, null )
  },

  removeDevice( device ) {
    return this.device( device ).delete()
    //    return this.delete( `v1/system/${device.systemId}/device/${device.id}` )
  },

  setValue( device, path, value ) {
    if ( Array.isArray( path ) ) {
      return this.device( device ).setValue( { values : path } )
    }
    if ( Array.isArray( value ) && path == null ) {
      return this.device( device ).setValue( { values : value } )
    }
    return this.device( device ).setValue( path, value )
  },

  setDeviceUpdater( device, path, updater, options ) {
    return this.device( device ).setUpdater( path, updater, options )
    // return this.put( `v1/system/${device.systemId}/device/${device.id}/updater`, { path : path, updater : updater } )
  },

  getDeviceUpdater( device, path, options ) {
    return this.device( device ).getUpdater( path, options )

    // options = { ...options, path : path }
    // return this.get( `v1/system/${device.systemId}/device/${device.id}/updater${encodeQ(options)}` )
  },

  getDeviceUpdaters( device, options ) {
    return this.device( device ).getUpdaters( options )
    //    return this.get( `v1/system/${device.systemId}/device/${device.id}/updater${encodeQ(options)}` )
  },

  // options = { start : <string parsable by new Date()), end : <option date string>}
  getHistorical( device, options ) {
    return this.device( device ).getHistorical( options )
    //    return this.get( `v1/system/${device.systemId}/device/${device.id}/historical${encodeQ(options)}` )
  },

  // network devices
  getSharedNetworks( ) {
    return this.get( 'v1/sharedNetwork' )
  },

  getSharedNetwork( networkId, options ) {
    return this.get( `v1/sharedNetwork/${networkId}${encodeQ( options )}` )
  },

  getNetworks( project, options ) {
    project = getId( project )
    return this.get( `v1/project/${project}/network${encodeQ( options )}` )
  },

  getNetwork( project, networkId, options ) {
    project = getId( project )
    return this.get( `v1/project/${project}/network/${networkId}${encodeQ( options )}` )
  },

  addNetwork( project, network ) {
    project = getId( project )
    return this.post( `v1/project/${project}/network`, network );
  },

  updateNetwork( network, patchOps ) {
    patchOps = getPatchOpsArray( patchOps )
    return this.patch( `v1/project/${network.projectId}/network/${network.id}`, patchOps )
  },

  removeNetwork( network ) {
    return this.delete( `v1/project/${network.projectId}/network/${network.id}` )
  }

  // ----------- Generic calls 
}

// function getId( objOrId ) {
//   if ( typeof objOrId === 'object' ) {
//     return objOrId.id
//   }
//   return objOrId
// }

function addDeprecated( api ) {
  Object.keys( Dep ).forEach( ( k ) => {
    if ( api[k] == null ) {
      api[k] = Dep[k]
    }
  } )

}

exports.addDeprecated = addDeprecated
